import { Button } from "@/components/button";
import { FONT } from "@/styles/common";
import { Flex, Text } from "@chakra-ui/react";
import styled from "@emotion/styled";

export const CustomTitle = styled(Text)`
    width: 100%;
    ${FONT("notoSerif", 24, 600, 1.4)}
    color : #6b6b6b;

    @media (max-width: ${({ theme }) => theme.MEDIA.tablet}) {
        ${FONT("notoSerif", 16, 400, 1.4)}
    }
`;

export const CustomFlex = styled(Flex)`
    z-index: 2;
    opacity: 0;
    transition: 1s cubic-bezier(0.215, 0.61, 0.355, 1);

    &.on {
        opacity: 1;
        visibility: visible;
    }

    &.off {
        opacity: 0;
        visibility: hidden;
    }
`;

interface CustomSpecialNavProps {
    index: number;
}

export const CustomSpecialNav = styled(Button)<CustomSpecialNavProps>`
    ${FONT("cormorant", 20, 500)}
    height:64px;
    color: ${({ theme }) => theme.COLOR.white};
    background: ${({ theme }) => theme.COLOR.black};
    border-left: ${({ index }) => (index % 3 !== 0 ? "1px dotted" : "none")};
    border-top: ${({ index }) => (index >= 3 ? "1px dotted" : "none")};

    @media (max-width: ${({ theme }) => theme.MEDIA.tablet}) {
        ${FONT("cormorant", 12, 500, 1)}
        height: 48px;
    }

    &:hover {
        color: ${({ theme }) => theme.COLOR.black};
        background: ${({ theme }) => theme.COLOR.white};
        box-shadow: 0 0 4px rgba(0, 0, 0, 0.1);
    }
`;

interface CustomBoxProps {
    pathName: string;
}

export const CustomBox = styled(Flex)<CustomBoxProps>`
    @media (max-width: ${({ theme }) => theme.MEDIA.tablet}) {
        width: 100%;
        background: ${({ theme }) => theme.COLOR.white};
        padding: ${({ pathName }) => pathName.includes("/specials") && "24px 0"};
    }
`;

export const CustomButton = styled(Button)`
    width: auto;
    ${FONT("cormorant", 16, 700)}
    padding:0 12px;
    color: ${({ theme }) => theme.COLOR.white};
    background: ${({ theme }) => theme.COLOR.black};

    @media (max-width: ${({ theme }) => theme.MEDIA.mobile}) {
        margin-left: 20px;
    }
`;
